// =============================================================================
// TERMS PAGE COMPONENT
// =============================================================================

import React, { useEffect } from 'react';
import { Navbar, Footer } from '@/components/Layout';
import { ContentRenderer } from '@/components/ContentRenderer';
import { SEOHead } from '@/components/SEO';
import { termsPageComponents } from '@/data/legalPageContent';
import { navItems, footerLinks, socialLinks } from '@/data/homeContent';
import { seoData } from '@/data/seoData';

export const TermsPage: React.FC = () => {
  const seo = seoData.terms;
  
  // Handle hash-based deep linking
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    };

    // Handle initial hash
    handleHashScroll();

    // Handle hash changes
    window.addEventListener('hashchange', handleHashScroll);
    return () => window.removeEventListener('hashchange', handleHashScroll);
  }, []);
  
  return (
    <div className="terms-page">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        noIndex={seo.noIndex}
      />
      
      <Navbar 
        brand="Awani"
        navItems={navItems}
        showThemeSwitcher={true}
      />
      
      <main className="main-content">
        <ContentRenderer components={termsPageComponents} />
      </main>
      
      <Footer
        brand="Awani"
        description="Terms of service for Awani. Read our terms and conditions for purchasing luxury alpaca wool clothing, custom orders, and returns."
        links={footerLinks}
        socialLinks={socialLinks}
      />
    </div>
  );
};
